export default "__VITE_ASSET__DwIfS18M__"